import React from "react";
import { canAny } from "./can.ts";
import type { Permission } from "./types.ts";
import { useUser } from "./useUser.ts";

interface GuardProps {
    permission: Permission;
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

export default function Guard({ permission, children, fallback }: GuardProps) {
    const user = useUser();

    if (canAny(user?.roles || [], permission)) {
        return <>{children}</>
    }

    return <>{fallback}</>
}